/**
 * GeoJSON 폴리곤 좌표 기반 point-in-polygon 판정.
 *
 * opinet 은 도(道) 대도시를 시 단위로만 저장(예: "경기 성남시")하므로 일반구(분당구 등)를
 * 이름으로 분리할 수 없다. 클릭한 구의 GeoJSON 폴리곤 안에 주유소 좌표가 있는지로
 * 클라이언트에서 필터하기 위한 유틸.
 *
 * 주의: GeoJSON 좌표 순서는 [lng, lat] 이다. ray casting 은 x=lng, y=lat 로 수행한다.
 */

/** ray casting: 점이 단일 ring(닫힌 다각형) 내부에 있는지. ring 은 [lng, lat][]. */
function isPointInRing(lng: number, lat: number, ring: number[][]): boolean {
  if (ring.length < 3) return false;
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const xi = ring[i][0]; // lng
    const yi = ring[i][1]; // lat
    const xj = ring[j][0]; // lng
    const yj = ring[j][1]; // lat
    const intersect =
      yi > lat !== yj > lat &&
      lng < ((xj - xi) * (lat - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}

/** Polygon(coordinates: number[][][], [0]=외곽 ring, 이후=구멍) 내부 판정. */
function isPointInPolygon(lng: number, lat: number, rings: number[][][]): boolean {
  if (!rings || rings.length === 0) return false;
  // 외곽 ring 내부가 아니면 false
  if (!isPointInRing(lng, lat, rings[0])) return false;
  // 어떤 구멍에라도 들어가면 false
  for (let i = 1; i < rings.length; i++) {
    if (isPointInRing(lng, lat, rings[i])) return false;
  }
  return true;
}

/**
 * 점(lat, lng)이 GeoJSON geometry 내부에 있는지 판정한다.
 * Polygon / MultiPolygon 만 지원하며, 그 외 타입은 false.
 */
export function isPointInGeometry(
  lat: number,
  lng: number,
  geometry: GeoJSON.Geometry
): boolean {
  if (geometry.type === 'Polygon') {
    return isPointInPolygon(lng, lat, geometry.coordinates);
  }
  if (geometry.type === 'MultiPolygon') {
    // 하나의 polygon 이라도 내부면 true
    return geometry.coordinates.some(polygon => isPointInPolygon(lng, lat, polygon));
  }
  return false;
}
